export default __webpack_public_path__ + "static/Entenda0145-4329f59bd68337fcd21f8ecadb87979b.jpg";